




/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// customerRegister
// CUSTOMERREGISTER
const GETJOBBYID= createAsyncThunk(
  "getJobById/getJobById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getJobByIdSlice = createSlice({
  name: "getJobByIdSlice",
  initialState: {
    getJobById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetJobById: (state) => {
        state.getJobById.loading = false
        state.getJobById.error = false
        state.getJobById.data = []
        state.getJobById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETJOBBYID.fulfilled, (state, action) => {
      state.getJobById = {
        ...state.getJobById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETJOBBYID.pending, (state, action) => {
      state.getJobById = {
        ...state.getJobById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETJOBBYID.rejected, (state, action) => {
      state.getJobById = {
        ...state.getJobById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getJobByIdAction = {
    GETJOBBYID,
};

export { getJobByIdAction };
export default getJobByIdSlice.reducer;
export const {setInitialStateOfgetJobById} = getJobByIdSlice.actions
